// action types for the pre contracts
export const SET_INVOICES = "SET_INVOICES";
export const SET_MODAL_DOCUMENTS = "SET_MODAL_DOCUMENTS";
export const SET_INVOICE = "SET_INVOICE";
